import LayoutBasic from '@/layouts/basic'

const meta = {
  auth: true,
}

const pre = 'system-'

export default {
  path: '/system',
  name: 'system',
  redirect: {
    name: `${pre}config`,
  },
  meta,
  component: LayoutBasic,
  children: [
    {
      path: 'config/:symbol',
      name: `${pre}config`,
      meta: {
        ...meta,
        title: '业务配置',
      },
      component: () => import('@/views/system/config'),
    },
  ],
}
